// extracted by mini-css-extract-plugin
export default {"modalBox":"modalStyle_modalBox__RyBn3","title":"modalStyle_title__O1VPt","description":"modalStyle_description__rpsDP","control":"modalStyle_control__jLR+r"};